import { ArrowOutward, Warning } from "@mui/icons-material";
import { FC, useEffect } from "react";
import css from "./SubscriptionExpired.module.css";
import buttonCss from "../../common-styling/Button.module.css";
import { useServices } from "../../services/Services";
import { API_URL } from "../../auth/client";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { useNavigate } from "react-router-dom";

const SubscriptionExpired: FC<object> = function ({}) {
  const services = useServices();
  const { data: user } = services.User.useGetCurrent();
  const navigate = useNavigate();
  const hasBypass = !!user?.paymentBypassReason;
  const { data: stripeDetails, isFetched: stripeDetailsFetched } =
    services.User.useGetStripeDetails(hasBypass ? undefined : user?.email);

  useDocumentTitle("Subscription Expired");

  useEffect(() => {
    if (hasBypass) {
      navigate("/", { replace: true });
    }
  }, [hasBypass, navigate]);
  function openBillingPage() {
    if (stripeDetails?.billingPortalUrl) {
      window.open(stripeDetails?.billingPortalUrl, "_blank");
    } else {
      location.href = API_URL + "/multipass/login";
    }
  }
  return (
    <div className={css.container}>
      <Warning className={css.icon} fontSize="inherit" />
      <h2>Active Subscription Required</h2>
      <p>Please ensure you have a valid subscription to access the product.</p>
      <p>
        <button
          className={buttonCss["action-button"]}
          onClick={openBillingPage}
          disabled={!stripeDetailsFetched}
        >
          Manage Subscription
          <ArrowOutward className={css["external-link"]} />
        </button>
      </p>
    </div>
  );
};
export default SubscriptionExpired;
